var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('club-layout',[_c('panel-blue'),_c('div',{attrs:{"id":"container"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }